import styled, { css } from 'styled-components';

const PremiumSectionContainer = styled.div`
  display: flex;
  flex-grow: 1;
  width: 100%;
  justify-content: center;
  padding-top: 32px;
  padding-bottom: 32px;
  background-color: var(--grey100);
  ${(props) =>
    !!props.background &&
    css`
      background: ${props.background};
    `};
  ${(props) =>
    !!props.noPadding &&
    css`
      padding: 0;
    `};
`;
export default PremiumSectionContainer;
